import React from 'react';

interface BrandMarkProps {
  className?: string;
}

const BrandMark: React.FC<BrandMarkProps> = ({ className = '' }) => (
  <svg
    className={className}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M7 23.5V19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M12.5 23.5V15.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M18 23.5V12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path
      d="M7 14.5L13 9.5L17 12L25 5.5"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 5.5H25V10"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BrandMark;
